/*
 * Fonts — Free fallback set (Phase 0).
 * Upgrade path: swap to GT Sectra Display + GT America Mono once licensed.
 */

@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,900;1,900&family=EB+Garamond:ital,wght@0,400;1,500&family=Space+Mono:wght@400;700&display=swap");
